module.exports = __webpack_public_path__ + "722fa02d3d493c25167daaf16278d476.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/mer-tail-green-s.png
// module id = 1311
// module chunks = 0